import React from 'react';

import { Input } from '@/ui/TextField';

type ManagementSearchPhraseProps = {
  placeholder: string;
  value: string;
  onChange: (searchPhrase: string) => void;
  fullWidth?: boolean;
};

export const ManagementSearchPhrase = ({ placeholder, value, onChange, fullWidth }: ManagementSearchPhraseProps): JSX.Element => (
  <Input
    label=""
    value={value}
    fullWidth={fullWidth || false}
    onChange={(e) => onChange(e.currentTarget.value)}
    placeholder={placeholder}
    leadingIcon="search"
  />
);
